import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "vant/lib/index.css";
// import Picker from "vant/lib/button";
import { Popup, Picker, Icon, ShareSheet } from "vant";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Icon);
Vue.use(ShareSheet);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 点击外部隐藏指令
Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
